





























import {
  Prop,
  Vue,
  Component,
  Watch
} from "@/shared/vuepack";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import DocumentSignatureDynamicTemplate from "@/shared/components/DocumentSignatureDynamicTemplate.vue";
import { FetchState, SigningDocumentContentType } from "@/shared/types";
import moment from "moment";
import { useNotifierStore } from "@/shared/store/notifier";
import { useSigningDocumentStore } from "@/admin/store/signingDocument";
import { isMobileApp } from "@/shared/mobileHelper";

@Component({
  components: {
    GenericLoadingSpinner,
    DocumentSignatureDynamicTemplate
  }
})
export default class DocumentSignatureView extends Vue {
  notifierStore = useNotifierStore();
  signingDocumentStore = useSigningDocumentStore();

  @Prop()
  documentKey: string;

  @Prop()
  print: boolean;

  @Prop({ required: false, default: false })
  hideSignature: boolean;

  SigningDocumentContentType = SigningDocumentContentType;
  moment = moment;
  dynamicTemplateData = {};

  mounted () {
    this.signingDocumentStore.getSignature(this.documentKey);
  }

  @Watch("signingDocumentStore.signatureFetchState", { deep: true })
  onSignatureFetchStateChange () {
    if (this.signingDocumentStore.signatureFetchState === FetchState.Loaded) {
      if (this.signingDocumentStore.isSigned) {
        this.signingDocumentStore.get(
            { documentKey: this.documentKey, version: this.signingDocumentStore.signature.documentVersion });
        for (const item of this.signingDocumentStore.signature.metaData) {
          this.dynamicTemplateData[item.key] = item.value;
        }
      } else {
        this.notifierStore.setDanger("Document not found");
      }
    }
  }

  @Watch("signingDocumentStore.documentFetchState", { deep: true })
  onDocumentFetchStateChange () {
    if (this.print && this.signingDocumentStore.isDocumentLoaded) {
      setTimeout(() => {
        window.print();
      }, 1000);
    }
  }

  get isMobile () {
    return isMobileApp();
  }
}
